import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-blue-900 text-white mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">NHM Plomberie</h3>
            <p className="text-blue-200">
              Votre expert en plomberie à Paris 17e. Service rapide et professionnel.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Liens rapides</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-blue-200 hover:text-white transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-blue-200 hover:text-white transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/zone-intervention" className="text-blue-200 hover:text-white transition-colors">
                  Zone d'intervention
                </Link>
              </li>
              <li>
                <Link to="/urgences" className="text-blue-200 hover:text-white transition-colors">
                  Urgences 24/7
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-blue-200 hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-blue-200 hover:text-white transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-blue-200 hover:text-white transition-colors">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-blue-200 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:0970705863" className="flex items-center gap-2 text-blue-200 hover:text-white transition-colors">
                  <Phone size={18} />
                  <span>09 70 70 58 63</span>
                </a>
              </li>
              <li>
                <a href="mailto:contact@nhm-plomberie.fr" className="flex items-center gap-2 text-blue-200 hover:text-white transition-colors">
                  <Mail size={18} />
                  <span>contact@nhm-plomberie.fr</span>
                </a>
              </li>
              <li className="flex items-start gap-2 text-blue-200">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span>18 rue Legendre<br />75017 Paris</span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Horaires</h4>
            <div className="flex items-start gap-2 text-blue-200">
              <Clock size={18} className="mt-1 flex-shrink-0" />
              <div>
                <p>Lundi - Vendredi: 8h - 19h</p>
                <p>Samedi: 9h - 17h</p>
                <p className="mt-2 font-semibold text-white">Urgences 24/7</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-blue-800 mt-8 pt-8 text-center text-blue-200">
          <p>&copy; {new Date().getFullYear()} NHM Plomberie. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};